import React, { useEffect, useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import axios from "axios";

import './ChatbotStats.css';

const ChatbotStats = () => {
  const [categoryData, setCategoryData] = useState([]);
  const [monthlyData, setMonthlyData] = useState([]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/chatbot/stats`);
        const { categoryStats, monthlyStats } = response.data;

        setCategoryData(categoryStats.map((c) => ({ label: c._id || "Sem Assunto", value: c.count })));
        setMonthlyData(monthlyStats);
      } catch (error) {
        console.error("Erro ao buscar estatísticas do chatbot:", error);
      }
    };

    fetchStats();
  }, []);

  // Gráfico de Pizza - Categorias
  const pieData = {
    labels: categoryData.map((c) => c.label),
    datasets: [
      {
        data: categoryData.map((c) => c.value),
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50", "#FF9800"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50", "#FF9800"],
      },
    ],
  };

  // Gráfico de Barras - Mensal
  const barData = {
    labels: monthlyData.map((m) => m.date),
    datasets: [
      {
        label: "Interações por Mês",
        data: monthlyData.map((m) => m.count),
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  const barOptions = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,  // Permite controle total sobre tamanho
    plugins: {
      legend: {
        display: true,
        position: 'bottom',  // Posiciona a legenda abaixo do gráfico
        maxHeight: 50,       // Define um limite máximo para a altura da legenda
        labels: {
          boxWidth: 10, // Reduz o tamanho do retângulo da legenda 
          padding: 10, // Adiciona espaçamento entre os itens da legenda         
          font: {
            size: 12, // Ajusta o tamanho da fonte
          },
          usePointStyle: true,  // Usa estilos de pontos menores
          padding: 10,          // Espaçamento interno entre os itens da legenda
        },
      },
      tooltip: {
        enabled: true, // Exibe tooltips ao passar o mouse
      },
    },
  };

  return (
    <div>
      <div className="chart-stat-container">
        <h3 className="chart-stat-title">Chatbot por Categoria</h3>
        <div className="chart-content-stats">
          <Pie data={pieData} options={options} />
        </div>
      </div>
    </div>
  );
};

export default ChatbotStats;
